import { HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChild, HostListener, NgZone } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { AppConfigService } from 'src/app/core/services/app-config.service';
import { AppMessagesService } from 'src/app/core/services/app-messages.service';
import { AppServiceService } from 'src/app/core/services/app-service.service';
import { SiteStettingService } from 'src/app/core/services/site-stetting.service';

@Component({
  selector: 'app-login-via-otp-moe',
  templateUrl: './login-via-otp-moe.component.html',
  styleUrls: ['./login-via-otp-moe.component.scss']
})
export class LoginViaOtpMoeComponent implements OnInit {


  @Output() loginViaPassword = new EventEmitter();
  idCardForm: FormGroup;
  verificationCodeForm: FormGroup;
  restartcode: boolean;
  showVerificationCode: boolean = false;
  phoneNumberWithAsterisks: string;
  verificationCodeInvalid: boolean;
  sitekey: string;
  CaptchaNeeded:boolean;
  message:string="";
  links:any;
  updatePhone:string;
  loader:boolean = false;
  HTMLContent = "<p>כדי שנוכל לזהות אותך, אנו זקוקים לכל 9 הספרות של ת.ז שלך, כולל ספרת ביקורת. אם אין לך ת.ז, אנו זקוקים למספר הדרכון שלך המורכב מ 16 ספרות ואותיות.</p>";
  service : any;
  isValidFormSubmitted : boolean = false;
  phone:string='';
  constructor(private formBuilder: FormBuilder
    , private _siteSettingService: SiteStettingService, private activatedRoute:ActivatedRoute,
     private _router: Router , private appMessagesService :AppMessagesService , 
     private appConfigService:AppConfigService , private appService:AppServiceService) {   
        
     }
 

 
  get verificationCode() {
    return this.verificationCodeForm.controls.verificationCode;
  }

  ngOnInit(): void { 
    this.appService.componentName = 'login-via-otp-moe-component';
      document.getElementById("otpMoe").focus();
      this.phone = this.appService.mobileOtp;
    
    this.service = this.appConfigService.service;
    this.appConfigService.getLinks().subscribe(
      (data) => {
        this.links = data;
      },
      (error)=>{
        //TODO
      })
    this.updatePhone = this.links.updateDetailsMoe;
    this.CaptchaNeeded = this._siteSettingService.CaptchaNeeded;
    this.sitekey = window['_siteSettings'].recaptchaSiteKey;
    this.verificationCodeForm = this.formBuilder.group({
      verificationCode: new FormControl('', { validators: [Validators.required] }),
    });
  }

  checkVerificationCode(captchaResponse?: any) {
    this.isValidFormSubmitted = true;
    if (this.verificationCodeForm.invalid) {
      grecaptcha.reset();
      document.getElementById("otpMoe").focus();
       return;
    }
    this.loader = true;
    if(captchaResponse == undefined)
    captchaResponse = " ";
    this.service.sendOtp(this.verificationCodeForm.value.verificationCode , captchaResponse).subscribe(data => {
      if(data){
        this.CaptchaNeeded =this._siteSettingService.CaptchaNeeded = data.isCaptchaNeeded;
      if (data.isError == false){
        this.appService.redirectTourl();
          }
      else {
        this.loader = false;
       
        if(data.errorCode =='INTRUDER_DETECTED'){
          this.appMessagesService.errorCode = data.errorCode ;
           this._router.navigate(['locked'], { skipLocationChange: true });       
      }
      else
      {
        if (data.errorCode == 'TOKEN_TOKEN_EXPIRED') {
          this.message = this.appMessagesService.returnErrorMessage('TOKEN_NOT_FOUND')
          }
         else
         { 
           this.message = this.appMessagesService.returnErrorMessage(data.errorCode);
          }
        this.loader = false;
        this.verificationCodeForm.reset();
        grecaptcha.reset();
        this.isValidFormSubmitted = false;
        document.getElementById("otpMoe").focus();
      }
    
 }
      }
    }, err => {
     
    }).add(() => {
  //     setTimeout(()=>{ 
  //       this.message = "";                          
  //  }, 5000);
    });;
  }


  resetMassage(){
    this.message = "";
  }

  back(){
    this.appService.doReset(); 
  }



  openLinkInEdge(){   
    const userAgent = window.navigator.userAgent.toLowerCase();    
    if(userAgent.indexOf('edge') > -1 || userAgent.indexOf('edg/') > -1){   
      window.open(this.updatePhone, "_blank"); 
    }
else{ 

  window.open('microsoft-edge:' + this.updatePhone);
}
  }

  }
